import { createSelector } from 'reselect';
import { getAllSchemaVersions } from './all';

export var getSchemaVersionForResource = function getSchemaVersionForResource(selector) {
  return createSelector(getAllSchemaVersions, selector, function (allSchemaVersions, resource) {
    var id = resource ? resource['@id'] || resource.id : null;
    if (!id) {
      return null;
    }
    return allSchemaVersions ? allSchemaVersions[id] || null : null;
  });
};